module.exports = __webpack_public_path__ + "img/BRAVO_enterior.0aea7fe3.jpg";